// Copyright (c) 2016 Deere & Company

import {
    applySearchFilters,
    resetAllFacets,
    selectAllDealersOnInitialLoad,
    toggleDealerAccountFacetItems,
    togglePipTypeFacetItems,
    updateDealerAccountFacetItem,
    updatePipTypeFacetItem
} from './facets';
import {
    updateListFilterBy,
    updateListSortBy,
    updateListSortDirection
} from '../../../shared/action-creators/refine-list';
import {readFacetsData} from './read-facets-data';
import {readLaborAdditivePipsData} from '../../open-pips/action-creators/open-pips';
import {readOpenPipsData} from '../../labor-additive/action-creators/labor-additive';
import sharedActionCreators from '../../shared/action-creators';
import {updateSearchResults} from './select-search-by';

export default {
    ...sharedActionCreators,
    applySearchFilters,
    readFacetsData,
    readLaborAdditivePipsData,
    readOpenPipsData,
    resetAllFacets,
    selectAllDealersOnInitialLoad,
    toggleDealerAccountFacetItems,
    togglePipTypeFacetItems,
    updateDealerAccountFacetItem,
    updateListFilterBy,
    updateListSortBy,
    updateListSortDirection,
    updatePipTypeFacetItem,
    updateSearchResults
};




// WEBPACK FOOTER //
// ./src/pip/pip-search/action-creators/index.js